import { render, staticRenderFns } from "./LoginTest.vue?vue&type=template&id=079990c2&scoped=true"
import script from "./LoginTest.vue?vue&type=script&setup=true&lang=js"
export * from "./LoginTest.vue?vue&type=script&setup=true&lang=js"
import style0 from "./LoginTest.vue?vue&type=style&index=0&id=079990c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "079990c2",
  null
  
)

export default component.exports